// @codekit-prepend "components/ppcarto.bar.action.item.js";
// @codekit-prepend "components/ppcarto.bar.actions.js";
// @codekit-prepend "components/ppcarto.bar.section.item.js";
// @codekit-prepend "components/ppcarto.bar.sections.js";
// @codekit-prepend "components/ppcarto.card.js";
// @codekit-prepend "components/ppcarto.drawer.js";
// @codekit-prepend "components/ppcarto.filter.js";
// @codekit-prepend "components/ppcarto.icons.js";
// @codekit-prepend "components/ppcarto.list.js";
// @codekit-prepend "components/ppcarto.map.js";
// @codekit-prepend "components/ppcarto.popup.js";
// @codekit-prepend "components/ppcarto.rome2rio.js";
// @codekit-prepend "components/ppcarto.switch.js";
// @codekit-prepend "components/ppcarto.tripwizard.js";
// @codekit-prepend "components/ppcarto.typeahead.js";

Vue.prototype.$http = axios;

const store = new Vuex.Store({
	state: {
		count: 0,
		sections: [],
		actions: [],
		bbox: [],
		layers: {},
		rome2rio: {
			from: null,
			to: null,
			origin: {},
			destination: {},
			visible: false
		},
		history: [],
		r2rresults: {},
		highlight: null,
		showmap: false
	},
	getters: {
		selectedSections: (state) => {
			return state.sections.filter(section => section.selected)
		},
		activeCategories: (state) => {
			return state.sections.filter(section => section.selected).map(s => {
				return {
					section: s.key,
					categories: s.categories.filter(c => c.active).map(c => {
						return c.key
					})
				}
			})
		},
		inactiveCategories: (state) => {
			return state.sections.filter(section => section.selected).map(s => {
				return {
					section: s.key,
					categories: s.categories.filter(c => !c.active).map(c => {
						return c.key
					})
				}
			})
		},
		allSections: (state) => {
			return state.sections;
		},
		getActions: (state) => {
			return state.actions;
		},
		selectedActions: (state) => {
			return state.actions.filter(section => section.selected)
		},
		getBoundingBox: (state) => {
			return state.bbox;
		},
		getRome2Rio: (state) => {
			return state.rome2rio;
		},
		getRome2RioData: (state) => {
			return state.r2rresults;
		},
		getHistory: (state) => {
			return state.history;
		},
		getHighlight: (state) => {
			return state.highlight;
		},
		getLayerStatus: (state) => {
			return state.layers;
		},
		showMap: (state) => {
			return state.showmap;
		}

	},
	mutations: {
		increment(state) {
			state.count++
		},
		setSections(state, sections) {
			state.sections = sections
		},
		toggleSection(state, section) {

			let s = state.sections.filter(s => s.key == section.key)[0]
			s.selected = !s.selected

			if (s.selected) {
				state.history.push({
					key: s.key,
					name: s.name,
					selected: s.selected,
					action: false
				});
			} else {
				state.history = state.history.filter(h => h.key != s.key);
			}
		},
		toggleSectionCategory(state, change) {
			let s = state.sections.filter(s => s.key == change.section.key)[0];
			let c = s.categories.filter(c => c.key == change.category.key)[0];

			if (c.active) {
				c.active = !c.active
			} else {
				c.active = true;
			}
		},
		setActions(state, actions) {
			state.actions = actions
		},
		toggleAction(state, action) {

			let s = state.actions.filter(s => { return s.key == action.key })[0]

			console.log(state.actions);
			s.selected = !s.selected



			if (s.selected) {
				state.history.push({
					key: s.key,
					name: s.name,
					selected: s.selected,
					action: true
				});
			} else {
				state.history = state.history.filter(h => {
           return h.key != s.key
         });
			}

		},

		switchTo(state, key) {
			let history = state.history;
			let item = _.remove(history, (h, i, a) => {
				return h.key == key;
			});

			history.push(item);
			state.history = _.flatten(history);
		},

		setBoundingBox(state, bbox) {
			state.bbox = bbox;
		},
		setRome2Rio(state, options) {
			state.rome2rio = options;
		},
		setRome2RioData(state, data) {
			state.r2rresults = data;
		},
		setHighlight(state, item) {
			state.highlight = item;
		},
		setLayerStatus(state, options) {
			//console.log(options)
			state.layers[options.key] = options.status;
		},
		toggleMap(state) {
			state.showmap = !state.showmap;
		}

	}
})

var ppcarto = new Vue({
	el: '#ppcarto',
	store,
	computed: {
		selectedSections() {
			return this.$store.getters.selectedSections
		},
		activeCategories() {
			return this.$store.getters.activeCategories
		}
	},
	data: {
		sections: []
	},

	created() {
		// this.$http.get('http://api.kw.pixelpoint.biz/api/geo/sections').then((response) => {
		// 	let sections = response.data.sections;
		// 	_.each(sections, s => {
		// 		s.selected = false;
		// 		_.each(s.categories, c => {
		// 			c.active = false
		// 		})
		// 	});
		// 	this.sections = sections;
		// 	this.$store.commit('setSections', this.sections);
		// });

		let actions = [{
			name: 'plan journey',
			key: 'rome2rio',
			action: 'rome2rio',
			selected: false
		}]

		this.$store.commit('setActions', actions);
	},

	methods: {
		openTrip(destination){
			let action = _.find(this.$store.getters.getActions, a => a.key == 'rome2rio');
      let rome2rio = this.$store.getters.getRome2Rio;
      this.$store.commit('setRome2Rio', {
        origin: rome2rio.origin || null,
        destination: destination || null,
        from: rome2rio.origin.longName || null,
        to: destination.longName || null,
        visible: true
      })


      if(this.$store.getters.showMap) this.$store.commit('toggleMap');

      if(!action.selected) this.$store.commit('toggleAction', action);
		}
	},

	watch: {
		selectedSections(x) {
			//console.dir(x);
		},
		activeCategories(x) {
			//console.dir(x);
		},
	},
})
